// Strongly-typed accessor for the runtime configuration shipped via
// `public/config.js` (dev) or `/usr/share/nginx/html/config.js` (prod, rendered
// from env vars at container start).
//
// The script is loaded BEFORE the React bundle (see index.html), so by the
// time any module executes, `window.__WHOSOUT_CONFIG__` is already populated.

type Cfg = {
  entraTenantId: string;
  entraClientId: string;
  entraApiScope: string;
  // Empty string ⇒ same-origin.
  apiBaseUrl: string;
};

declare global {
  interface Window {
    __WHOSOUT_CONFIG__?: Cfg;
  }
}

function loadConfig(): Cfg {
  const c = window.__WHOSOUT_CONFIG__;
  if (!c) {
    throw new Error(
      "Missing window.__WHOSOUT_CONFIG__. " +
        "In dev: copy public/config.js.example to public/config.js. " +
        "In prod: the nginx entrypoint failed to render config.js — check container logs.",
    );
  }
  for (const k of ["entraTenantId", "entraClientId", "entraApiScope"] as const) {
    if (!c[k]) {
      throw new Error(`Runtime config field "${k}" is empty.`);
    }
  }
  return c;
}

export const config = loadConfig();
